import Converter from './Converter';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  authRequired: false,
  gameListUrl: 'bluejack/game_list',
  gameListUrlData: {
    getHeaders: () => ({
      headers: { 'x-partner-name': projectName },
    }),
  },
  converter,
  sessionUrlData: {
    url: 'bluejack/token',
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
    getHeaders: () => ({
      headers: {
        'x-partner-authorization': parseCookies(),
        'x-partner-name': projectName,
      },
    }),
  },
};
